export const PROMPT_ID = 'f966a877-69b6-4bf8-9d93-ae54c4608cc8';
export const FALLBACK_KIT_ID = 'modest';
